let error = {
	// 401:'请登录后查看'
}


export default error